import React from 'react';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {prizeInfo, coursePrize, prizeProps} from './data';
import {Container, Image, Ul} from '../../../Components/Atom';
import {viewSize, colorPalette} from '../../../config';
import {expiredIMG} from '../../../config/images';
import styled from 'styled-components';

export const ExpiredImg = styled.img`
	width: 100%;
	@media screen and (max-width: ${viewSize.mobile}) {
		width: 100%;
	}
`;

export const ExpiredText = styled.div`
	color: ${colorPalette.white};
	font-family: 'Gmarket';
	font-size: 35px;
	font-weight: 600;
	text-align: center;
	@media screen and (max-width: ${viewSize.mobile}) {
		font-size: 20px;
	}
`;

const Award = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '시상안내']} />
			{/* <ExpiredText>준비중입니다.</ExpiredText>
			<ExpiredImg src={expiredIMG} /> */}
			{/* <Image {...prizeProps} /> */}
			<CardSection {...prizeInfo} />
			<CardSection {...coursePrize} />
		</Container>
	);
};

export default Award;
